import React from 'react';
import { isNil } from 'lodash';

import { COLORS, NEUTRAL_TEXT0 } from '../../config/designSystem/Colors';
import { MaterialIcons } from '@expo/vector-icons';
import { ParagraphLBold, ParagraphSBold } from '../../config/designSystem/typography';
import { TouchableOpacity } from 'react-native';
import { View } from 'react-native';

interface ButtonProps {
  color?: string;
  backgroundColor?: string;

  onPress: () => void;
  label: string;
  withIcon?: boolean;
  nameIcon?:string;
  icon?:string;
  width?: number;
  marginBottom?: number;
  marginTop?: number;
  marginHorizontal?: number;
  height? : number;
  paddingVertical? : number;
  paddingHorizontal? : number;
  smallText?: boolean;
}

export const DEFAULT_PADDING_HORIZONTAL_BUTTON = 20;
export const DEFAULT_PADDING_VERTICAL_BUTTON = 15;

export const DEFAULT_MARGIN_BOTTOM_BUTTON = 15;
export const DEFAULT_MARGIN_TOP_BUTTON = 15;
export const DEFAULT_MARGIN_HORIZONTAL_BOTTOM = 20;

export const DEFAULT_BORDER_RADIUS = 40;


const Button = ({ color,backgroundColor, onPress, withIcon, icon, label, width,nameIcon, marginBottom, marginTop,smallText,marginHorizontal, height, paddingHorizontal, paddingVertical }: ButtonProps) => {
  const MARGIN_BOTTOM = !isNil(marginBottom)? marginBottom: DEFAULT_MARGIN_BOTTOM_BUTTON;
  const MARGIN_TOP = !isNil(marginTop)? marginTop: DEFAULT_MARGIN_TOP_BUTTON;
  const MARGIN_HORIZONTAL = !isNil(marginHorizontal)? marginHorizontal: DEFAULT_MARGIN_HORIZONTAL_BOTTOM;
  const PADDING_VERTICAL = !isNil(paddingVertical)? paddingVertical: DEFAULT_PADDING_VERTICAL_BUTTON;
  const PADDING_HORIZONTAL = !isNil(paddingHorizontal)? paddingHorizontal: DEFAULT_PADDING_HORIZONTAL_BUTTON;
  const COLOR= color?color:COLORS.brand[500] ;
  const BACKGROUND_COLOR= backgroundColor?backgroundColor :NEUTRAL_TEXT0;
  const SIZE = height?height*0.6:20;
  return (
    <TouchableOpacity
      style={[
        {
          borderWidth:2,
          borderColor:COLOR,
          backgroundColor:BACKGROUND_COLOR,
          paddingVertical: PADDING_VERTICAL,
          marginHorizontal: MARGIN_HORIZONTAL,
          borderRadius: DEFAULT_BORDER_RADIUS,
          justifyContent: 'center',
          alignItems: 'center',
          marginTop:MARGIN_TOP,
          marginBottom: MARGIN_BOTTOM,
          paddingHorizontal: PADDING_HORIZONTAL,
          flexDirection:'row',
          width: '90%',
          maxWidth: 600,

        },
        !!width && { width },
        !!height && {height}
      ]}
      onPress={onPress}
    >



      {!!label && (<>
        {smallText? (<ParagraphSBold align={true} color={COLOR}>
          {label}
        </ParagraphSBold>) :(<ParagraphLBold align={true} color={COLOR}>
          {label}
        </ParagraphLBold>) }
      </>)}
      {withIcon && <View style={{marginLeft: 7}}>{
        (icon && icon === 'MaterialIcons') && <MaterialIcons name={nameIcon as any} color='#fff' size={SIZE} />
      }</View>}
    </TouchableOpacity>
  );
};

export default Button;
